
import { Component, Mixins } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { scrollToInPage, scrollToElementById } from '@/features/common/helpers';
import ColoredWidget from '../ColoredWidget.vue';
import { WidgetMixin } from '../widgetMixin';

@Component({
  components: {
    ColoredWidget,
  },
})
export default class ShippingTips extends Mixins(ResponsivenessMixin, WidgetMixin) {
  get btnCustomizeDisabled(): boolean {
    return this.$store.getters.getShowCustomizeTooltip;
  }

  get isBigWidgetAvailable(): boolean {
    return this.$store.getters.getIsBigWidgetAvailable;
  }

  get isSmallWidgetAvailable(): boolean {
    return this.$store.getters.getIsSmallWidgetAvailable;
  }

  get isWidgetsAvailable(): boolean {
    return !!this.isBigWidgetAvailable || !!this.isSmallWidgetAvailable;
  }

  private customizeDashboard(): void {
    if (!this.isWidgetsAvailable) {
      this.$store.commit('setCustomizeTooltipStep', 3);
    }

    if (this.isDesktop && !this.isBigWidgetAvailable) {
      scrollToInPage(0, 100, true);
    }

    if (this.isDesktop && this.isBigWidgetAvailable) {
      scrollToInPage(0, 150, true);
    }

    if (this.isTablet || this.isMobile) {
      setTimeout(() => {
        scrollToElementById('tooltip-marker');
      }, 100);
    }

    this.$store.commit('setShowCustomizeTooltip', true);
  }
}
